export default __webpack_public_path__ + "static/media/switchPivot.01ac3b63.svg";